import { useState } from 'react';
import { LogIn } from 'lucide-react';
import { api, tokens } from '../lib/api';
import { Marke } from '../components/Shell';

export function Login({ aufAngemeldet }: { aufAngemeldet: () => void }) {
  const [name, setName] = useState('');
  const [pw, setPw] = useState('');
  const [fehler, setFehler] = useState<string | null>(null);
  const [laeuft, setLaeuft] = useState(false);

  async function absenden(e: React.FormEvent) {
    e.preventDefault();
    setLaeuft(true);
    setFehler(null);
    try {
      const d = await api<{ access_token: string; refresh_token?: string }>('/auth/login', {
        method: 'POST',
        body: JSON.stringify({ username: name, password: pw }),
      });
      tokens.set(d.access_token, d.refresh_token);
      aufAngemeldet();
    } catch (err) {
      setFehler(err instanceof Error ? err.message : 'Anmeldung fehlgeschlagen');
    } finally {
      setLaeuft(false);
    }
  }

  return (
    <div className="anmelden">
      <form className="karte anmelden__karte" onSubmit={absenden}>
        <div className="anmelden__marke"><Marke size={34} /></div>
        <div className="stapel">
          {fehler && <div className="hinweis hinweis--schlecht">{fehler}</div>}
          <div>
            <label className="label" htmlFor="l-user">Benutzername</label>
            <input id="l-user" className="feld" value={name} autoFocus autoComplete="username"
              onChange={(e) => setName(e.target.value)} />
          </div>
          <div>
            <label className="label" htmlFor="l-pw">Passwort</label>
            <input id="l-pw" className="feld" type="password" value={pw} autoComplete="current-password"
              onChange={(e) => setPw(e.target.value)} />
          </div>
          <button className="knopf knopf--haupt" type="submit" disabled={laeuft || !name || !pw}
            style={{ justifyContent: 'center' }}>
            <LogIn size={16} /> {laeuft ? 'Moment …' : 'Anmelden'}
          </button>
        </div>
      </form>
    </div>
  );
}
